import { effects } from 'redux-saga';
import * as Sentry from '@sentry/react';

import { ClientError, NotFoundError, SessionExpirationError } from '@occc-app/lib/client';
import { navigateTo } from '@occc-app/lib/router';

const redirect = function* () {
  const fromPath = window.location.pathname;
  yield navigateTo('/refresh', { lastUrl: fromPath });
};

const fourOhFour = function* (path: string) {
  const pathParts = path.split('/');
  const id = pathParts[pathParts.length - 1];
  const rawResource = pathParts[pathParts.length - 2];

  // Capitalize first letter, remove trailing `s` from resource name
  const resource = rawResource.charAt(0).toUpperCase() + rawResource.slice(1, -1);
  yield navigateTo(`/not-found?resource=${resource}&id=${id}`);

  return Promise.resolve();
};

type Method<Action extends {}> = (action: Action) => void;
type ErrorHandler<Action extends {}> = (error: Error, action: Action) => { type: string };
const safeAsync = <Action extends {}>(
  method: Method<Action>,
  errorHandler?: ErrorHandler<Action>,
) => {
  return function* (action: Action) {
    try {
      yield method(action);
    } catch (err) {
      if (errorHandler) {
        yield effects.put(errorHandler(err, action));
      }

      if (err instanceof ClientError) {
        Sentry.captureException(err);
      }

      if (err instanceof NotFoundError) {
        yield fourOhFour(err.requestedPath);
      }

      if (err instanceof SessionExpirationError) {
        yield redirect();
      }
    }
  };
};

export { safeAsync };
